export enum UserSubscriptionPeriod {
    none = 'none',
    monthly = 'monthly',
    annually = 'annually'
}

export interface SubscriptionProduct {
    id: string;
    name: string;
    description: string;
    sku: string;
    price: number;
    currency: string;
    billing_period: 'monthly' | 'annually';
    trial_days: number;
    stripe_price_id: string;
    payment_link: string;
    features?: string[];
}


export enum UserSubscriptionStatus {
    none = 'none',
    active = 'active',
    past_due = 'past_due',
    unpaid = 'unpaid',
    canceled = 'canceled',
    expired = 'expired',
    trialing = 'trial',
    paused = 'paused'
}

export type SimpleSubscriptionStatus = 'none' | 'active' | 'expired' | 'processing';

export interface UserSubscription {
    id: string;
    email: string;
    status: UserSubscriptionStatus;
    period: UserSubscriptionPeriod;
    plan_type?: 'core' | 'plugin';
    start_date?: Date;
    end_date?: Date;
    trial_start?: Date;
    trial_end?: Date;
    stripe_customer_id?: string;
    stripe_price_id?: string;
    stripe_subscription_id?: string;
    created_at: Date;
    updated_at: Date;
    product_snapshot?: UserSubscriptionProductSnapshot | 'trial';
    plugin_features?: string[];
    push_pull_features?: UserPushPullFeatures;
    plugin_subscription?: UserPluginSubscription | null;
    is_organization_subscription?: boolean; // True if this subscription comes from organization membership
    organization_name?: string; // Name of organization if using organization subscription
    is_organization_owner?: boolean; // True if user is the organization owner (can see billing info)
    canceled_at_period_end?: boolean; // True if subscription is set to cancel at end of billing period
}

export interface UserPluginSubscription {
    status: UserSubscriptionStatus;
    period: UserSubscriptionPeriod;
    start_date?: Date;
    end_date?: Date;
    canceled_at_period_end?: boolean;
    product_snapshot?: UserSubscriptionProductSnapshot | 'trial';
}

export interface UserPushPullFeatures {
    organic: boolean;
    prismatic: boolean;
    native_parametric: boolean;
}

export type UserSubscriptionProductSnapshot = {
    product_name?: string;
    product_description?: string;
    product_sku?: string;
    product_price?: number;
    product_quantity: number;
    product_manufacturing_features?: string[];
    product_cad_generation_features?: string[];
    product_platform_features?: string[];
    product_load_case_features?: string[];
    product_constraints_features?: string[];
    product_cad_download_features?: string[];
    product_plugin_features?: string[];
};

export enum CadDownloadFeatures {
    ORGANIC = 'Organic',
    PRISMATIC = 'Prismatic'
}


export interface UserCreateSubscriptionDto {
    email: string;
    status: UserSubscriptionStatus;
    period: UserSubscriptionPeriod;
    plan_type?: 'core' | 'plugin';
    start_date?: Date;
    end_date?: Date;
    trial_start?: Date;
    trial_end?: Date;
    product_snapshot?: UserSubscriptionProductSnapshot | 'trial';
}

export interface UserUpdateSubscriptionDto {
    status?: UserSubscriptionStatus;
    period?: UserSubscriptionPeriod;
    plan_type?: 'core' | 'plugin';
    start_date?: Date;
    end_date?: Date;
    trial_start?: Date;
    trial_end?: Date;
    product_snapshot?: UserSubscriptionProductSnapshot | 'trial';
}
